import * as React from 'react';
import type { Trip } from 'contracts/tracking-v2/trips';
import { Table, TableBody, TableCell, TableHeader, TableRow } from 'components/ui/table';
import { cn } from 'lib/utils';

import { getInvoiceItemInfo } from './utils';

type Props = React.ComponentProps<'div'> & {
  items: Trip['invoices'][number]['items'];
};

export const InvoiceItems = ({ className, items }: Props) => {
  return (
    <div className={cn(className)}>
      <Table>
        <TableHeader>
          <TableRow className={'text-slate-400 text-sm font-GilroySemibold'}>
            <TableCell>Código prod.</TableCell>
            <TableCell>Descrição do produto</TableCell>
            <TableCell>Lote</TableCell>
            <TableCell className={'text-right'}>Lote Qtd.</TableCell>
            <TableCell>Pedido</TableCell>
            <TableCell className={'text-right'}>Qtd.</TableCell>
            <TableCell className={'text-right'}>Valor unitário</TableCell>
            <TableCell className={'text-right'}>Valor total</TableCell>
          </TableRow>
        </TableHeader>
        <TableBody>
          {items.map(item => {
            const info = getInvoiceItemInfo(item);
            return (
              <TableRow key={item.id} className={'text-gray-600 text-sm font-sans'}>
                <TableCell>{info.productCode}</TableCell>
                <TableCell>{info.productDescription}</TableCell>
                <TableCell>{info.batch}</TableCell>
                <TableCell className={'text-right'}>{info.batchQuantity}</TableCell>
                <TableCell>{info.orderNumber}</TableCell>
                <TableCell className={'text-right'}>{info.quantity}</TableCell>
                <TableCell className={'text-right'}>{info.unitValue}</TableCell>
                <TableCell className={'text-right'}>{info.totalValue}</TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </div>
  );
};